import React, { Component } from 'react';
import ReactModal from 'react-modal';

export default class Modal extends Component {
  render() {
    return (
      <ReactModal
        onRequestClose={this.props.onRequestClose}
        isOpen={this.props.visible}
        style={styles}
        closeTimeoutMS={200}
      >
        {this.props.children}
      </ReactModal>
    );
  }
}

const styles = {
  overlay: {
    backgroundColor: 'transparent',
  },
  content: {
    backgroundColor: 'transparent',
    borderWidth: 0,
    padding: 0,
    right: 0,
    left: 0,
    top: 0,
    bottom: 0,
    borderRadius: 0,
    display: 'flex',
  },
};
